module.exports = __webpack_public_path__ + "static/media/female_skeleton.01c23ebb.png";